import { Box, Skeleton } from "@mui/material";

export default function AreaFieldItemLoader() {
  return (
    <Box sx={{ position: "absolute", width: "100%" }}>
      <Skeleton animation="wave" variant="rectangular" height={30} sx={{ bgcolor: "#ffffff1c" }} />
    </Box>
  );
}
